import React, { useState } from 'react';
import { Alert, Box, TextField } from '@mui/material';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

function formatContactError(err) {
  const detail = err.response?.data?.detail;
  if (typeof detail === 'string' && detail.trim()) {
    return detail;
  }
  if (Array.isArray(detail) && detail[0]?.msg) {
    return detail.map((item) => item.msg).join(' ');
  }
  if (err.code === 'ECONNREFUSED' || err.message === 'Network Error') {
    return 'Cannot reach the Diligence Desk API. Confirm FastAPI is running on port 8000.';
  }
  return err.message || 'Unable to send request. Please try again.';
}

export async function sendContactRequest(payload) {
  const response = await axios.post(`${API_BASE_URL}/contact`, payload);
  return response.data;
}

export function useContactSubmit() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);

  const resetStatus = () => {
    setError('');
    setSent(false);
  };

  const submit = async (payload) => {
    setLoading(true);
    setError('');
    try {
      await sendContactRequest(payload);
      setSent(true);
      return true;
    } catch (err) {
      setError(formatContactError(err));
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { submit, loading, error, sent, resetStatus };
}

export function ContactAlerts({ error, sent }) {
  if (sent) {
    return <Alert severity="success">Request sent. We will be in touch.</Alert>;
  }
  if (error) {
    return <Alert severity="error">{error}</Alert>;
  }
  return null;
}

export function HoneypotField({ value, onChange }) {
  return (
    <Box
      aria-hidden="true"
      sx={{ position: 'absolute', left: '-9999px', height: 0, overflow: 'hidden' }}
    >
      <TextField
        tabIndex={-1}
        autoComplete="off"
        label="Leave blank"
        name="hp_leave_blank"
        value={value}
        onChange={onChange}
      />
    </Box>
  );
}
